var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWlSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#6941C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.017 4.884L9.55297 10.5H7.89697L7.00097 6.804L6.07297 10.5H4.41697L2.99297 4.884H4.45697L5.26497 8.972L6.26497 4.884H7.76897L8.72897 8.972L9.54497 4.884H11.017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlSmall);
export default __webpack_public_path__ + "static/media/wl-small.35bbbd0eae883f4e2d1977a0e6c97c5d.svg";
export { ForwardRef as ReactComponent };